import React, { useEffect, useState } from 'react';
import { useContent } from '../../contexts/ContentContext';
import { normalizeWhatsAppPhone } from '../../utils/whatsapp';
import './FeaturedProgramsAdmin.css';

const WhatsAppNumbersAdmin = ({ contentPath = 'global.socialMedia' }) => {
  const { getContent, updateContent } = useContent();
  const [socialData, setSocialData] = useState(null);

  useEffect(() => {
    setSocialData(getContent(contentPath) || {});
  }, [contentPath, getContent]);

  const numbers = socialData?.whatsappNumbers || [];

  const handleUpdate = (field, value) => {
    updateContent(`${contentPath}.${field}`, value);
    setSocialData(getContent(contentPath));
  };

  const handleNumberChange = (index, field, value) => {
    const next = numbers.map((entry, i) =>
      i === index
        ? {
            ...entry,
            [field]: field === 'phone' ? value : value,
          }
        : entry
    );
    handleUpdate('whatsappNumbers', next);
  };

  const handleAdd = () => {
    const id = numbers.length === 0 ? 'primary' : `whatsapp-${Date.now()}`;
    handleUpdate('whatsappNumbers', [
      ...numbers,
      {
        id,
        label: numbers.length === 0 ? 'Numéro principal' : 'Nouveau numéro',
        phone: '+213797607481',
      },
    ]);
  };

  const handleRemove = (index) => {
    if (numbers.length <= 1) return;
    if (!window.confirm('Supprimer ce numéro WhatsApp ?')) return;
    handleUpdate(
      'whatsappNumbers',
      numbers.filter((_, i) => i !== index)
    );
  };

  if (!socialData) {
    return (
      <div className="programs-admin-loading">
        <i className="fas fa-spinner fa-spin" />
        <p>Chargement...</p>
      </div>
    );
  }

  return (
    <div className="programs-admin">
      <div className="admin-section-header">
        <div className="section-info">
          <h2>
            <i className="fab fa-whatsapp" /> Numéros WhatsApp
          </h2>
          <p>
            Numéro principal utilisé sur le site (contact, CTA). Pour un numéro différent par formation,
            modifiez directement le champ « Numéro WhatsApp » dans chaque programme ou formation.
          </p>
          <p style={{ color: '#64748b', fontSize: '0.9rem', marginTop: '0.5rem' }}>
            Les icônes Facebook, Instagram, LinkedIn et YouTube se gèrent dans{' '}
            <strong>Page Contact → Réseaux sociaux (footer & contact)</strong>.
          </p>
        </div>
        <button type="button" className="btn-add-program" onClick={handleAdd}>
          <i className="fas fa-plus" /> Ajouter un numéro
        </button>
      </div>

      <div className="programs-list-admin">
        {numbers.map((entry, index) => (
          <div key={entry.id || index} className="program-item-admin">
            <div className="program-header">
              <div className="program-title-area">
                <h3>{entry.label || `Numéro ${index + 1}`}</h3>
                <span className="program-badge">ID: {entry.id}</span>
              </div>
              {numbers.length > 1 && (
                <div className="program-actions">
                  <button type="button" className="btn-delete" onClick={() => handleRemove(index)}>
                    <i className="fas fa-trash" />
                  </button>
                </div>
              )}
            </div>
            <div className="section-settings">
              <div className="form-group">
                <label>Libellé (admin)</label>
                <input
                  type="text"
                  value={entry.label || ''}
                  onChange={(e) => handleNumberChange(index, 'label', e.target.value)}
                  placeholder="Ex: Inscriptions"
                />
              </div>
              <div className="form-group">
                <label>Identifiant (ne pas modifier sauf besoin)</label>
                <input
                  type="text"
                  value={entry.id || ''}
                  onChange={(e) => handleNumberChange(index, 'id', e.target.value.replace(/\s+/g, '-'))}
                  placeholder="primary"
                />
              </div>
              <div className="form-group">
                <label>Numéro (avec indicatif pays)</label>
                <input
                  type="text"
                  value={entry.phone || ''}
                  onChange={(e) => handleNumberChange(index, 'phone', e.target.value)}
                  placeholder="+213797607481"
                />
                <small style={{ color: '#64748b' }}>
                  Normalisé: {normalizeWhatsAppPhone(entry.phone) || '—'}
                </small>
              </div>
            </div>
          </div>
        ))}
      </div>

      {numbers.length === 0 && (
        <div className="empty-state">
          <p>Aucun numéro configuré. Ajoutez au moins un numéro principal.</p>
          <button type="button" className="btn-add-first" onClick={handleAdd}>
            Ajouter le numéro principal
          </button>
        </div>
      )}
    </div>
  );
};

export default WhatsAppNumbersAdmin;
